import {
  FusionSettingsApi,
  useAuthenticatedAPIConfig,
  useFormSubmit,
} from "melco-shared-logic";
import { BasicSettingsFormValueType } from "./useBasicSettingsFormSubmit";

export const useFusionBasicSettingsFormSubmit = () => {
  const authenticatedApiConfig = useAuthenticatedAPIConfig();

  const onSubmit = useFormSubmit<BasicSettingsFormValueType>(
    async (values: BasicSettingsFormValueType, { resetForm }) => {
      const {
        default_embroidery_production_file_format,
        measurement_unit,
        enable_production_links,
      } = values;

      const api = new FusionSettingsApi(authenticatedApiConfig());
      await api.settingsEditFusionAppSetting({
        fusionMelcoFusionModelsFusionAppSetting: {
          default_embroidery_production_file_format:
            default_embroidery_production_file_format,
          measurement_unit,
          enable_production_links,
        },
      });

      resetForm({ values });

      return { successMessages: [{ message: "default" }] };
    },
    { translationPrefix: "settings.basic" }
  );

  return onSubmit;
};
